/**
 * Subscription Management Platform API
 * This document describes the functionality of the API belonging to the Subscription Management Platform ## Parameters ### Parameters with type \"array[string]\" or \"array[integer]\" should be given as multiple parameters with same key and different values    * param=A&param=B&param=C    * param=0&param=1&param=2
 *
 * OpenAPI spec version: 2.0.7
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface CERTIFICATE {
    serialNumber: string;
    caId: string;
    subject: string;
    keyUsage: number;
    effectiveDate: string;
    expirationDate: string;
    casdImage?: string;
    discretionaryData?: string;
    /**
     * Base64 encoded
     */
    publicKey: string;
    /**
     * Algorithm
     */
    algo: CERTIFICATE.AlgoEnum;
    /**
     * Base64 encoded
     */
    signature: string;
    privateKeyId?: number;
}
export namespace CERTIFICATE {
    export type AlgoEnum = 'P256' | 'BRAINPOOLP256R1' | 'FRP256V1';
    export const AlgoEnum = {
        P256: 'P256' as AlgoEnum,
        BRAINPOOLP256R1: 'BRAINPOOLP256R1' as AlgoEnum,
        FRP256V1: 'FRP256V1' as AlgoEnum
    }
}



// WEBPACK FOOTER //
// ./src/gen/swagger-api/model/cERTIFICATE.ts